export default function (refs) {
  return {
    steps: [
      {
        intro: 'Welcome to your profile page. We will take you on a brief '
          + 'tour outlining how to link your device and upload your data!',
      },
      {
        element: refs.introStep1,
        intro: 'This biometric information is necessary to calculate your individualized metrics. '
          + '(You can go ahead and update and save your height and weight '
          + 'without interrupting this guided tour!)',
      },
      {
        element: refs.introStep2,
        intro: 'This is where you link your watch to the dashboard. Simply select '
          + 'the icon that matches your watch and the system will walk you through the process.',
      },
    ],
  };
}
